import { createIcon } from '@chakra-ui/react';

export const Logout = createIcon({
  displayName: 'Logout',
  viewBox: '0 0 24 24',
  path: (
    <g id="Group_2840" data-name="Group 2840" transform="translate(-57 -709)">
      <rect
        id="Icon_Space"
        data-name="Icon Space"
        transform="translate(57 709)"
        fill="none"
      />
      <g
        id="Sign_Out_-_L"
        data-name="Sign Out - L"
        transform="translate(57.269 710.025)"
      >
        <path
          id="Sign_Out_-_L-2"
          data-name="Sign Out - L"
          d="M11.6,13.28a.524.524,0,0,0-.521.524v7.8H1.625V1.544h9.459v7.8a.528.528,0,0,0,1.055,0V1.027A.524.524,0,0,0,11.6.5H1.1a.524.524,0,0,0-.524.527v21.1a.524.524,0,0,0,.524.527H11.6a.524.524,0,0,0,.524-.527V13.8a.524.524,0,0,0-.524-.524Zm10.933-2.057L16.979,5.668a.522.522,0,1,0-.739.738L20.9,11.055H3.806a.527.527,0,1,0,0,1.055H20.9l-4.668,4.655a.521.521,0,0,0,.739.735l5.565-5.555a.52.52,0,0,0,0-.721Z"
          transform="translate(-0.58 -0.5)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
